<template>
 
      <v-data-table
        id="campaign-list-table"
        :loading="loading"
        :headers="headers"
        :items="campaignList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [5, 10, 25, 50, 75, 100],
        }"
        :items-per-page="perPage"
        hide-default-header
        item-key="id"
        class="elevation-2  mx-1 campaign-list-table"
      >
        <template v-slot:[`item.customHeader`]="{ item }">
          <v-container class="service-campaign-view">
            <v-row>
              <v-col
                cols="12"
                sm="8"
                class="pa-0"
              >
                <div class="subtitle-1 d-flex">
                  <v-icon color="#03B6FC">mdi-email</v-icon>
                  <div class="ml-3 subtitle-1 font-weight-medium word-break text-ellipsis">{{ item.title }}</div>
                </div>
              </v-col>
               <v-col class="text-right pa-0" cols="12" sm="4">
                 <p
                  class="body-2"
                >{{ $options.filters.formatDateTZ(item.action_time) }}</p>
              </v-col>
              <v-col
                cols="12"
                class="d-flex pt-0 pr-0 pb-1"
              >
              <div class="mt-3 ml-6 mr-auto">
                <v-chip
                  v-if="constants.STATUS[item.status.replace(/\s/g, '').toLowerCase()]"
                  outlined
                  small
                  :color="constants.STATUS[item.status.replace(/\s/g, '').toLowerCase()] ? constants.STATUS[item.status.replace(/\s/g, '').toLowerCase()].color : 'grey'"
                >
                  {{ item.status | upperCaseFirst }}
                </v-chip>
                <span v-if="item.resent">
                  <v-chip
                    color="#41CE65"
                    outlined
                    class="ml-2"
                    small>
                    Re-sent
                  </v-chip>
                  <br>
                  <span class="grey-color"> on {{$options.filters.formatDateTZ(item.resent_at)}} </span>
                </span>
              </div>
              <div>
                <v-tooltip
                  top
                  color="rgba(0, 0, 0, 0.9)"
                  :disabled="canResend(item)"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn class="mt-2 font-weight-bold" outlined
                      @click="openLink(getResendUrl(item))"
                      target="_blank"
                      v-track="'resend-campaign-btn'"
                      small
                      :style="!canResend(item)?'cursor:not-allowed;color: grey !important;':'cursor:pointer'"
                      :ripple="canResend(item)"
                      v-on="on"
                    >Re-send Campaign</v-btn>
                  </template>
                  <div v-if="dnm"> Campaign can't be re-sent to DNM contacts</div>
                  <div v-else-if="item.hard_bounced"> Campaign can't be re-sent to Hard bounced contacts</div>
                  <div v-else-if="item.transactional"> Campaign can't be re-sent in case of transactional campaigns</div>                        
                </v-tooltip>
              <v-btn
                  outlined
                  class = "mt-2 ml-4 font-weight-bold"
                  target="_blank"
                  v-track="'open-campaign-details'"
                  small
                  @click="openLink(`/accounts/${account.id}/campaigns/${item.id}`)"
                ><span>Details</span></v-btn>
              </div>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </v-data-table>
</template>
<script>
import { $marketingContacts } from "@core/services"
import constants from '@core/config/constants'
import { mapGetters } from "vuex"

export default {
    name: "contact-dashboard-campaigns",
    props: {
      contactInfo: {
        type: Object,
      }
    },
    data() {
        return {
          campaignList: [],
          headers: [
            { text: "", sortable: false, value: "customHeader" }
          ],
          perPage: 10,
          page: 1,
          totalItems: 0,
          pagination: {},
          loading: false,
          constants: constants,
          dnm: false,
          origin: window.location.origin,
        };
    },
    computed: {
      ...mapGetters({
        account: 'auth/account'
      })
    },
    mounted() {
      this.fetchCampaignList()
    },
    watch: {
      pagination: {
        handler(newVal, oldVal) {
          /** prevent this check to invoked function on page load */
          if (oldVal.itemsPerPage) {
            this.fetchCampaignList();
          }
        },
        deep: true,
      },
    },
    methods: {
      fetchCampaignList () {
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
        const sort = sortDesc.length ? (sortDesc[0] === true ? 'desc' : 'asc') : ''
        const payload = {
          page: page,
          per_page: itemsPerPage,
          'contact[email]': this.contactInfo.email,
        }
        if (sortBy[0]) { payload.method = sortBy[0] }
        if (sort) { payload.sort_by = sort }
        /**
         * [GET] API call with required payload
         */
        $marketingContacts.fetchAllCampaigns(this.contactInfo.id, {
          params: payload,
        }).then(response => {
          const result = response.data
          this.campaignList = result.data
          this.totalItems = result.meta.count
          this.$emit('total-items', this.totalItems)
        }).finally(() => {
          this.loading = false
        })
      },
      canResend (item){
        return !item.transactional && !item.hard_bounced && !this.dnm
      },
      /**
       * Method used for Marketing Cloud 
       */
      getResendUrl(item) {
       if(this.$route.params.listId){
        return `/accounts/${this.account.id}/lists/${this.$route.params.listId}/contacts/${this.contactInfo.id}/resend-campaign/${item.id}`
       }
       else { 
         return `/accounts/${this.account.id}/contacts/${this.contactInfo.id}/resend-campaign/${item.id}`
       }
      },
      openLink (url) {
        if (process.env.VUE_APP_PRODUCT == 'Marketing') {
          this.$router.push(url)
        } else {
          window.open(url, '_blank');
        }
      },
    },
};
</script>
<style lang="scss" scoped>
.grey-color{
  color:#999999;
}
</style>
